import React, { useMemo } from "react";
import { Modal } from "antd";
import { parseVoucherRulesSections } from "./voucherRules";
import styles from "./index.module.less";

function formatVoucherMsg(t, id, defaultMessage) {
  if (!t) return defaultMessage;
  try {
    const msg = t(id);
    if (msg && msg !== id) return msg;
  } catch {
    /* ignore */
  }
  return defaultMessage;
}

/**
 * 券规则详情弹窗（Figma Rule Details）
 */
export default function VoucherRulesModal({ open, content, onClose, t }) {
  const sections = useMemo(() => parseVoucherRulesSections(content), [content]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      maskClosable
      centered
      width={311}
      wrapClassName={styles.rulesModalWrap}
      bodyStyle={{ padding: 0 }}
      maskStyle={{ background: "rgba(0, 0, 0, 0.7)" }}
    >
      <div className={styles.rulesModalPanel}>
        <h2 className={styles.rulesModalTitle}>
          {formatVoucherMsg(t, "activity.voucherRuleDetailsTitle", "Rule Details")}
        </h2>
        <div className={styles.rulesModalBody}>
          {sections.length > 0 ? (
            sections.map((section, idx) => (
              <div key={idx} className={styles.rulesModalSection}>
                <p className={styles.rulesModalSectionTitle}>{section.title}</p>
                {section.bodyLines.length > 0 ? (
                  <div className={styles.rulesModalSectionBody}>
                    {section.bodyLines.map((line, lineIdx) => (
                      <p key={lineIdx}>{line}</p>
                    ))}
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <p className={styles.rulesModalEmpty}>—</p>
          )}
        </div>
        <button type="button" className={styles.rulesModalBtn} onClick={onClose}>
          {formatVoucherMsg(t, "activity.voucherModalOk", "OK")}
        </button>
      </div>
    </Modal>
  );
}
